import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=2287780d&scoped=true"
import script from "./ContactInfo.vue?vue&type=script&lang=js"
export * from "./ContactInfo.vue?vue&type=script&lang=js"
import style0 from "./ContactInfo.vue?vue&type=style&index=0&id=2287780d&prod&lang=css"
import style1 from "./ContactInfo.vue?vue&type=style&index=1&id=2287780d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2287780d",
  null
  
)

export default component.exports